export function formatTenantLabel(
  tenantExternalId: string | null,
  tenantId: string | null,
  fallback: string,
): string {
  return tenantExternalId ?? tenantId ?? fallback;
}

export function formatUserLabel(
  userExternalId: string | null,
  userId: string | null,
  fallback: string,
): string {
  return userExternalId ?? userId ?? fallback;
}

export function formatOptionalText(value: string | null | undefined, fallback: string): string {
  if (value == null || value.trim() === '') return fallback;
  return value;
}
